import { gql } from '@apollo/client'

const DELETE_REFERRAL_SOURCE = gql`
  mutation DELETE_REFERRAL_SOURCE($referralSource: ID!, $moveTo: ID!) {
    deleteReferralSource(referralSource: $referralSource, moveTo: $moveTo) {
      id
    }
  }
`

export default DELETE_REFERRAL_SOURCE
